// extracted by mini-css-extract-plugin
export default {"singlepage":"Singlepage_singlepage__ovKW-","info":"Singlepage_info__EjUPx","genre":"Singlepage_genre__L8osx"};